import { sendPost } from '@utils/request';

export const mySendPost = ({ url, data }) => {
  return sendPost({ url, data, baseURLStr: '/df-gw' })
    .then(res => {
      if (res && res.code === 'BFF000000') {
        return res.data;
      }

      // request里统一处理了error和toast，且没有抛出错误，导致异常进入了正常的业务逻辑，所以这里需要再次抛出异常。
      throw new Error(res);
    });
};

/**
 * 将新的省市区街道接口数据封装成旧的接口数据
 */
const transformAreaResponse = (data) => {
  return {
    data: data.records.map(({ id, name, enName }) => ({ id, nameCh: name, nameEn: enName || '', name, enName })),
  };
};

const tranformDefaultAddressResponse = (newData) => {
  return {
    body: {
      district: {
        id: newData.province.provinceId, name: newData.province.provinceName, enName: newData.province.provinceEnName,
      }, city: {
        id: newData.city.id, name: newData.city.cityName, enName: newData.city.cityEnName,
      }, region: {
        id: newData.region.regionId, name: newData.region.regionName, enName: newData.region.regionEnName,
      }, streets: newData.streets.map(street => ({
        id: street.streetId, name: street.streetName, enName: street.streetEnName,
      })),
    },
  };
};


function transformAddress(res){  
  if (res && res.records && res.records.length) {
    const processedRecords = res.records.map(record => ({
      ...record,
      id: record.addressId,
    }));
    
    res.records = processedRecords;
  }
  return res;
};

/**
 * 获取用户地址
 * */
export function getUserAddressListV2(data) {
  return mySendPost({ url: `/location/address/getuseraddresslist`, data }).then(transformAddress);
}

/**
 * 创建用户地址
 */
export const createUserAddressV2 = (data) => {
  return mySendPost({ url: `/location/address/createuseraddress`, data });
};

/**
 * 修改用户地址
 */
export function updateUserAddressV2(data) {
  return mySendPost({ url: `/location/address/updateuseraddress`, data });
}

/**
 * 删除用户地址
 */
export function deleteUserAddressV2(data) {
  return mySendPost({ url: `/location/address/deleteuseraddress`, data });
}

/**
 * 获取工会城市列表
 */
export function getUnionCityListV2(data) {
  return mySendPost({ url: `/location/union/getcitylist`, data });
}

/**
 * 省
 */
export const getAllProvince = (data) => {
  return mySendPost({ url: '/location/area/getallprovince', data }).then(transformAreaResponse);
};

/**
 * 市
 */
export const getAllCityByProvince = (data) => {
  return mySendPost({ url: '/location/area/getallcitybyprovince', data }).then(transformAreaResponse);
};

/**
 * 区
 */
export const getAllRegionByCity = (data) => {
  return mySendPost({ url: '/location/area/getallregionbycity', data }).then(transformAreaResponse);
};

/**
 * 街道
 */
export const getAllStreetByRegion = (data) => {
  return mySendPost({ url: '/location/area/getallstreetbyregion', data }).then(transformAreaResponse);
};

/**
 * 获取默认城市
 */
export const getDefaultAddress = (data) => {
  return mySendPost({ url: '/location/area/getdefaultaddress', data }).then(tranformDefaultAddressResponse);
};



/**
 * 格式化城市数据
 * @param res 
 * @returns 
 */
export function transformCities(res) {
  const data = res;

  if (!data) {
    console.error('数据格式错误或缺少必要字段');
    return res; // 保持原始数据结构不变
  }

  // 抽取一个通用的映射函数
  const mapCityList = (list) =>
    list.map((item) => ({
      ...item,
      cityId: item.id,
      name: item.cityName,
      pinyin: item.pinyin,
      first: item.aleph,
    }));
  return {
    ...data,
    cityList: mapCityList(data.cityList) || data.cityList,
    historyCities: mapCityList(data.historyCities) || data.historyCities,
    hotCities: mapCityList(data.hotCities) || data.hotCities,
  };
}
